import { useRef, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { useContext } from "react";
import TurnoPresencialIcon from "../../../assets/images/generico/TurnoPresencialIcon";
import TurnoVideoConsultaIcon from "../../../assets/images/generico/TurnoVideoConsultaIcon";
import { getDiaStrTurno } from "../../../../global/utils/diasTurno";
import { amOrPm } from "../../../../global/utils/amOrPm";
import "./CardMedico.css";
import { FaStar } from "react-icons/fa";
import camelize from "../../../../global/utils/camelize";

const CardMedico = ({ item, onClickModal }) => {
  const { misMedicosState } = useContext(PortalContext);
  const trackButton = useRef();
  const [valorMedico, setValorMedico] = useState(null);
  const [valorRecepcionista, setValorRecepcionista] = useState(null);
  const [valorTecnico, setValorTecnico] = useState(null);

  const stars = Array(5).fill(0);

  const starColor = {
    dorado: "#edce00",
    azul: "#0072B3",
    gris: "#E6E6E6",
  };

  const imgTittle =
    item.videoConsulta === true ? (
      <TurnoVideoConsultaIcon />
    ) : (
      <TurnoPresencialIcon />
    );

  useEffect(() => {
    if (item.encuesta) {
      if (
        misMedicosState.misMedicos.data &&
        misMedicosState.misMedicos.data !== ""
      ) {
        setValorMedico(item.encuesta.estrellas_medico);
        setValorRecepcionista(item.encuesta.estrellas_recepcion);
        setValorTecnico(item.encuesta.estrellas_tecnico);
      }
    } else {
      //limpio estados en caso de llegar null en encuesta, evito que queden datos cargados
      setValorMedico(null);
      setValorRecepcionista(null);
      setValorTecnico(null);
    }
    // eslint-disable-next-line
  }, [item.encuesta]);

  return (
    <div className="ptur-misMedicos-card" ref={trackButton}>
      <div className="ptur-misMedicos-titulo">
        <div className="ptur-misMedicos-especialidad">
          <span>{imgTittle}</span>
          <p className="rb18b">{camelize(item.especialidad)}</p>
        </div>
      </div>
      <div className="ptur-misMedicos-card-cuerpo">
        <p className="ptur-misMedicos-fecha rb16b">
          <span className="rb16l">Fecha:</span> {getDiaStrTurno(item.fecha)}
          <span className="rb16l">{getDiaStrTurno(item.fecha, true)}</span>
        </p>
        {item.idProtocolo > 0 ? (
          <>
            {item.tecnico !== null ? (
              <p className="ptur-misMedicos-turnoSolicitado">
                Técnico: <span className="rb16b">{camelize(item.tecnico)}</span>
              </p>
            ) : (
              ""
            )}
          </>
        ) : (
          <>
            <p className="ptur-misMedicos-turnoSolicitado">
              Horario:{" "}
              <span className="rb16b">
                {item.hora} {amOrPm(item.hora)}
              </span>
            </p>
            <p className="ptur-misMedicos-turnoSolicitado">
              {item.tecnico ? "Técnico:" : "Médico:"}{" "}
              {item.tecnico ? (
                <span className="rb16b">{camelize(item.tecnico)}</span>
              ) : (
                <span className="rb16b">{camelize(item.medico)}</span>
              )}
            </p>
          </>
        )}
      </div>
      <div className="ptur-misMedicos-pie">
        <div className="ptur-misMedicos-estrellas-boton-container">
          <div className="ptur-misMedicos-estrellas-container">
            {stars.map((_, index) => {
              return (
                <div
                  key={index}
                  style={{ cursor: "unset" }}
                  className={
                    (item.tecnico === null || item.tecnico === ""
                      ? item.medico == null || item.medico === ""
                        ? valorRecepcionista
                        : valorMedico
                      : valorTecnico) > index
                      ? "ptur-misMedicos-estrellas-dorado"
                      : "ptur-misMedicos-estrellas"
                  }
                >
                  <FaStar
                    key={index}
                    size={20}
                    color={
                      (item.tecnico === null || item.tecnico === ""
                        ? item.medico == null || item.medico === ""
                          ? valorRecepcionista
                          : valorMedico
                        : valorTecnico) > index
                        ? starColor.dorado
                        : starColor.gris
                    }
                    style={{
                      stroke: "black", // Color del borde
                      strokeWidth: "18px", // Grosor del borde
                    }}
                  />
                </div>
              );
            })}
          </div>
          <div className="ptur-misMedicos-botonCalificar">
            {item.encuesta !== null ? (
              <button
                onClick={onClickModal}
                className="ptur-misMedicos-botonCalificar-texto rb16m"
              >
                Modificar
              </button>
            ) : (
              <button
                onClick={onClickModal}
                className="ptur-misMedicos-botonCalificar-texto rb16m"
              >
                Calificar
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardMedico;
